/**
 * 시세 정보 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class QuoteService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 5단계 호가 조회
     * 종목의 5단계 호가 정보를 조회합니다.
     * @param stockCd - 조회할 종목코드
     * @returns 5단계 호가 조회 결과
     */
    getOrderBook(stockCd) {
        return this.axios.get(`/main/v1/quotes/${stockCd}/order-book`);
    }
    /**
     * 틱 차트 데이터 조회
     * 종목의 틱 차트 데이터를 조회합니다.
     * @param stockCd - 조회할 종목코드
     * @param request - 틱 차트 데이터 조회 요청 데이터
     * @returns 틱 차트 데이터 조회 결과
     */
    getTickChart(stockCd, request) {
        return this.axios.get(`/main/v1/quotes/tick-chart/${stockCd}/history`, {
            params: request,
        });
    }
    /**
     * 일별 OHLC 데이터 조회
     * 특정 날짜의 시가/고가/저가/종가 데이터를 조회합니다.
     * @param stockCd - 조회할 종목코드
     * @param request - 일별 OHLC 데이터 조회 요청 데이터
     * @returns 일별 OHLC 데이터 조회 결과
     */
    getStockDailyOHLC(stockCd, request) {
        return this.axios.get(`/main/v1/quotes/ohlc/${stockCd}`, {
            params: request,
        });
    }
    /**
     * 캔들 차트 데이터 조회
     * 종목의 캔들 차트 데이터를 조회합니다.
     * @param stockCd - 조회할 종목코드
     * @param request - 캔들 차트 데이터 조회 요청 데이터
     * @returns 캔들 차트 데이터 조회 결과
     */
    getCandleChart(stockCd, request) {
        return this.axios.get(`/main/v1/quotes/candle-chart/${stockCd}/history`, {
            params: request,
        });
    }
}
//# sourceMappingURL=quote.service.js.map